import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { ExistingOptionDefault_EditPage_Query } from "./query";

type Props = {
	hotelID: string;
	optionID: string;
};

export const useOptionEditQuery = ({ hotelID, optionID }: Props) => {
	const { data } = useCustomSuspenseQuery(ExistingOptionDefault_EditPage_Query, {
		variables: { hotelID, optionID },
	});

	return data;
};
